// extracted by mini-css-extract-plugin
export default {"icon":"CartIcon_icon__arX6Q","icon__fill":"CartIcon_icon__fill__uc+CJ","icon_active":"CartIcon_icon_active__bnZE1"};